import type { OpenInsurancePopupOptions } from "./InsurancePopup.types";

export const INSURANCE_POPUP_EVENT = "show-insurance-popup";
export const CLOSE_INSURANCE_POPUP_EVENT = "close-insurance-popup";

export const openInsurancePopup = (options?: OpenInsurancePopupOptions) => {
  window.dispatchEvent(
    new CustomEvent(INSURANCE_POPUP_EVENT, {
      detail: options || {},
    })
  );
};

export const closeInsurancePopup = () => {
  window.dispatchEvent(new CustomEvent(CLOSE_INSURANCE_POPUP_EVENT));
};
